// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41b2771c","239":"0a513c10","453":"ec71a25c","667":"f4812eb1","947":"2a0ecfe9"}[chunkId] + ".chunk.js";
};